import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import RCore from 'RCore';

const Flag = styled.figure`
    width: ${props => props.width}px;
    margin: 0;
    overflow: hidden;
    text-align: center;

    ${props =>
        props.theme.display.flag === 'round' &&
        `border-radius: 50%; width: ${props.height}px; height: ${props.height}px`};
    ${props => props.theme.display.flag === 'skew' && 'transform: skew(-15deg)'};
`;

const NationalFlag = props => {
    const { countryId, width, height } = props;
    const difference = 1.525;

    return (
        <Flag width={width} height={width / difference}>
            <img src={RCore.imageUrls.getFlagImg(countryId, width, height)} />
        </Flag>
    );
};

NationalFlag.contextTypes = {
    info: PropTypes.object
};

export default NationalFlag;
export { NationalFlag };




/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/NationalFlag.js
 **/